import styled from 'styled-components';

import media from '../../../utils/styling/media';

export const StyledButton = styled.button.attrs({ type: 'button' })`
  height: 42px;
  width: 42px;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.purple1};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.link};
  outline: 0;
  
  &:hover {
    border-color: ${({ theme }) => theme.colors.light};
  }

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }

  ${media.lg`
    height: 50px;
    width: 50px;
  `}
`;
